"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mapStatusToMultipleStatus = void 0;
const betweb_openapi_axios_1 = require("betweb-openapi-axios");
/**
 * New 'statuses' parameter for fetching bets history allows us provide more granular statuses
 *
 * Status COMPUTED deprecated and mapped to [ BetStatus.Won, BetStatus.Returned, BetStatus.Lost, BetStatus.Sold ]
 *
 * Status UNKNOWN deprecated and throws error
 * @param status:  BetStatus | undefined - undefined means "all" bets
 * @returns BetStatus[] | undefined
 */
function mapStatusToMultipleStatus(status) {
    if (status == null) {
        return [
            betweb_openapi_axios_1.BetStatus.Current,
            betweb_openapi_axios_1.BetStatus.Won,
            betweb_openapi_axios_1.BetStatus.Returned,
            betweb_openapi_axios_1.BetStatus.Lost,
            betweb_openapi_axios_1.BetStatus.Sold,
        ];
    }
    if (status === betweb_openapi_axios_1.BetStatus.Unknown) {
        throw Error('BetStatus.Unknown is deprecated');
    }
    const STATUS_MAP = {
        [betweb_openapi_axios_1.BetStatus.Current]: [betweb_openapi_axios_1.BetStatus.Current],
        [betweb_openapi_axios_1.BetStatus.Computed]: [
            betweb_openapi_axios_1.BetStatus.Won,
            betweb_openapi_axios_1.BetStatus.Returned,
            betweb_openapi_axios_1.BetStatus.Lost,
            betweb_openapi_axios_1.BetStatus.Sold,
        ],
        [betweb_openapi_axios_1.BetStatus.Won]: [betweb_openapi_axios_1.BetStatus.Won],
        [betweb_openapi_axios_1.BetStatus.Returned]: [betweb_openapi_axios_1.BetStatus.Returned],
        [betweb_openapi_axios_1.BetStatus.Lost]: [betweb_openapi_axios_1.BetStatus.Lost],
        [betweb_openapi_axios_1.BetStatus.Sold]: [betweb_openapi_axios_1.BetStatus.Sold],
        [betweb_openapi_axios_1.BetStatus.Canceled]: [betweb_openapi_axios_1.BetStatus.Canceled],
    };
    return STATUS_MAP[status];
}
exports.mapStatusToMultipleStatus = mapStatusToMultipleStatus;
//# sourceMappingURL=mapStatusToPluralStatuses.js.map